angular.module('unergie.main')
.filter('duration', (StringUtils) => {
    const units = {
        days: 'j',
        hours: 'h',
        minutes: 'm',
        seconds: 's',
        milliseconds: 'ms',
    }

    const formatDuration = function (duration) {
        let s = ''
        _.forEach(Object.keys(units), (unit) => {
            const value = duration[unit]()
            if (value) {
                if (s === '') {
                    s += `${value}${units[unit]}`
                } else {
                    s += ` ${StringUtils.leftPad(value, '00')}${units[unit]}`
                }
            }
        })
        return s
    }

    return (val, precision) => formatDuration(moment.duration(val, precision))
})
